module.exports = __webpack_public_path__ + "img/2.707666a5.webp";